import { render, staticRenderFns } from "./WhatsQueue.vue?vue&type=template&id=1f0852e0"
import script from "./WhatsQueue.vue?vue&type=script&lang=js"
export * from "./WhatsQueue.vue?vue&type=script&lang=js"
import style0 from "./WhatsQueue.vue?vue&type=style&index=0&id=1f0852e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports